import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');
    
    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, { signal });

    // Au premier chargement de la page, on applique le tri
    setTimeout(() => {
      this.#getVariantAndFilter();
    }, 100);
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
    // LE CORRECTIF EST ICI : 
    // On attend 50 millisecondes que le bouton soit bien cliqué dans la page,
    // puis on va lire sa valeur de force.
    setTimeout(() => {
      this.#getVariantAndFilter();
    }, 50);
  };

  #getVariantAndFilter() {
    // On va chercher le bouton qui est coché physiquement
    const radio = document.querySelector('.variant-picker-cards-container input[type="radio"]:checked');
    if (radio && radio.value) {
       this.#applyBrcFilter(radio.value);
    }
  }

  #applyBrcFilter(variantText) {
    const val = variantText.toUpperCase();
    let targetAlt = "";

    // Identification stricte de l'image à garder
    if (val.includes("ENDURANCE") || val.includes("6 BOI")) targetAlt = "6 piluliers";
    else if (val.includes("PERFORMANCE") || val.includes("CURE") || val.includes("3 BOI")) targetAlt = "3 piluliers";
    else if (val.includes("SOLO") || val.includes("1 BOI")) targetAlt = "1 pilulier";

    // On cible absolument tout (carrousel principal + miniatures)
    const elements = this.querySelectorAll('slideshow-slide, li.product-media-container, .thumbnail-list__item, .dialog-thumbnails-list__thumbnail');
    
    elements.forEach(element => {
      const img = element.querySelector('img');
      if (!img) return;

      const alt = (img.getAttribute('alt') || "").toLowerCase();
      
      if (alt.includes("pilulier")) {
        // C'est une image de pack
        if (alt.includes(targetAlt)) {
          this.#showElement(element);
        } else {
          this.#hideElement(element);
        }
      } else {
        // C'est une image universelle (lifestyle), on l'affiche toujours
        this.#showElement(element);
      }
    });

    // Synchronisation des points (dots) en bas du carrousel
    this.#updateDots();

    // On repositionne le carrousel au début pour éviter de rester bloqué sur un espace vide
    if (this.slideshow && typeof this.slideshow.select === 'function') {
      this.slideshow.select(0, undefined, { animate: false });
      window.dispatchEvent(new Event('resize')); // Force la mise à jour des flèches dorées
    }
  }

  // Fonction pour afficher proprement selon le type d'élément
  #showElement(element) {
    if (element.tagName.toLowerCase() === 'slideshow-slide') {
      element.removeAttribute('hidden'); // Le script slideshow.js va le recompter !
    } else {
      element.style.display = '';
    }
  }

  // Fonction pour cacher proprement selon le type d'élément
  #hideElement(element) {
    if (element.tagName.toLowerCase() === 'slideshow-slide') {
      element.setAttribute('hidden', ''); // Le secret pour que slideshow.js l'ignore
    } else {
      element.style.display = 'none';
    }
  }

  #updateDots() {
    const slides = Array.from(this.querySelectorAll('slideshow-slide'));
    const visibleSlidesCount = slides.filter(slide => !slide.hasAttribute('hidden')).length;
    const dots = this.querySelectorAll('.slideshow-controls__pagination .slideshow-controls__dot');
    
    dots.forEach((dot, index) => {
       dot.style.display = (index < visibleSlidesCount) ? '' : 'none';
    });
  }

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() { return this.refs.slideshow; }
  get media() { return this.refs.media; }
  get presentation() { return this.dataset.presentation; }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}